import { Popconfirm, Space, Table } from "antd";
import { useContext } from "react";
import { UserContext } from "../../../context";
import history from "../../../routes/history";

const { Column } = Table;
export default function LocalTable({
  locais,
  loading,
  handleTableChange,
  total,
  confirm,
}) {
  function cancel(e) {
    console.log(e);
  }
  const user = useContext(UserContext);
  return (
    <div>
      <Table
        loading={loading}
        size="small"
        pagination={{ pageSize: 10, total }}
        onChange={handleTableChange}
        style={{ width: "100%" }}
        dataSource={locais}
        rowKey="id"
      >
        <Column title="Código" dataIndex="id" key="id" />

        <Column title="Descrição" dataIndex="descricao" key="descricao" />
        <Column title="Estado" dataIndex="estado" key="estado" />
        <Column title="Cidade" dataIndex="cidade" key="cidade" />
        <Column
          title="Ação"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <a onClick={() => history.push(`/locais/${record.id}`)}>
                Visualizar
              </a>

              {user?.type === "ADM" && (
                <Popconfirm
                  title="Deseja deletar o local de embarque/desembarque?"
                  onConfirm={() => confirm(record)}
                  onCancel={cancel}
                  okText="Sim"
                  cancelText="Não"
                >
                  <a>Deletar</a>
                </Popconfirm>
              )}
            </Space>
          )}
        />
      </Table>
    </div>
  );
}
